import { getDefaultField } from '@shared/lib/fields/getDefaultField'

export const FEEDBACK_CATEGORIES = {
  ticketNotReceived: {
    type: 'ticketNotReceived',
    title: 'Не пришёл билет',
    fields: {
      email: getDefaultField('input_email', {
        required: true,
        settings: { label: 'Почта из заказа' },
      }),
      phone: getDefaultField('input_tel', {
        required: true,
        settings: { label: 'Телефон из заказа' },
      }),
      comment: getDefaultField('textarea', {
        required: true,
        settings: { label: 'Комментарий', placeholder: 'Опишите проблему подробнее, если необходимо' },
      }),
    },
  },
  ticketRefund: {
    type: 'ticketRefund',
    title: 'Возврат билетов',
    fields: null,
    externalLink: 'https://www.afisha.ru/refunds/',
  },
  ticketIssue: {
    type: 'ticketIssue',
    title: 'Проблема с билетом',
    fields: {
      email: getDefaultField('input_email', {
        required: true,
        settings: { label: 'Почта' },
      }),
      phone: getDefaultField('input_tel', {
        required: true,
        settings: { label: 'Телефон' },
      }),
      order: getDefaultField('input', {
        required: true,
        settings: { label: 'Номер заказа' },
      }),
      comment: getDefaultField('textarea', {
        required: true,
        settings: {
          label: 'Текст сообщения',
          placeholder: 'Опишите проблему подробнее',
        },
      }),
    },
  },
  paymentIssue: {
    type: 'paymentIssue',
    title: 'Проблема с оплатой',
    fields: {
      email: getDefaultField('input_email', {
        required: true,
        settings: { label: 'Почта' },
      }),
      phone: getDefaultField('input_tel', {
        required: true,
        settings: { label: 'Телефон' },
      }),
      comment: getDefaultField('textarea', {
        required: true,
        settings: {
          label: 'Текст сообщения',
          placeholder: 'Опишите, пожалуйста, последовательность действий, приводящих к ошибке и приложите  скриншот',
        },
      }),
    },
  },
  aiAssistantQuestion: {
    type: 'aiAssistantQuestion',
    title: 'Вопрос по AI ассистенту',
    fields: {
      email: getDefaultField('input_email', {
        required: true,
        settings: { label: 'Ваша почта' },
      }),
      comment: getDefaultField('textarea', {
        required: true,
        settings: { label: 'Текст сообщения', placeholder: 'Опишите, пожалуйста, ваш вопрос' },
      }),
    },
  },
  collaboration: {
    type: 'collaboration',
    title: 'Сотрудничество',
    fields: {
      email: getDefaultField('input_email', {
        required: true,
        settings: { label: 'Почта' },
      }),
      phone: getDefaultField('input_tel', {
        required: true,
        settings: { label: 'Телефон' },
      }),
      comment: getDefaultField('textarea', {
        required: true,
        settings: { label: 'Текст сообщения', placeholder: 'Опишите ваше предложение' },
      }),
    },
  },
  generalQuestion: {
    type: 'generalQuestion',
    title: 'Задать вопрос',
    fields: {
      email: getDefaultField('input_email', {
        required: true,
        settings: { label: 'Почта' },
      }),
      comment: getDefaultField('textarea', {
        required: true,
        settings: { label: 'Текст сообщения', placeholder: 'Опишите, пожалуйста, ваш вопрос' },
      }),
    },
  },
  edaCourseRefund: {
    type: 'edaCourseRefund',
    title: 'Возврат курсов «Еда.ру»',
    fields: {
      email: getDefaultField('input_email', {
        required: true,
        settings: { label: 'Почта из заказа' },
      }),
      phone: getDefaultField('input_tel', {
        required: true,
        settings: { label: 'Телефон из заказа' },
      }),
      order: getDefaultField('input', {
        required: true,
        settings: { label: 'Номер заказа' },
      }),
      comment: getDefaultField('textarea', {
        required: true,
        settings: { label: 'Текст сообщения', placeholder: 'Опишите, пожалуйста, ваш вопрос' },
      }),
    },
  },
}
